var _defs, _rect, _polygon, _path, _polygon2, _path2, _path3, _polygon3, _path4, _polygon4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaerskLogoRgb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 348.03 163.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#42b0d5;}.c{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Maersk_Logo_RGB") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 348.03,
    height: 163.28
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "126.08 93.63 126.08 69.65 132.46 69.65 140.55 87.57 148.51 69.65 154.62 69.65 154.62 93.63 149.36 93.63 149.36 79.68 143.29 93.63 137.69 93.63 131.54 79.76 131.54 93.63 126.08 93.63"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M163.16,93.63H157l10.64-24h7.61l10.71,24h-6.1l-2.11-4.78H165.2Zm12.63-9.28-4.4-10.17-4.3,10.17Z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "188.4 93.63 188.4 69.65 211.29 69.65 211.29 74.45 193.93 74.45 193.93 79.21 208.82 79.21 208.82 83.89 193.93 83.89 193.93 88.83 211.33 88.83 211.33 93.63 188.4 93.63"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M215.79,93.63v-24h19.15a3.69,3.69,0,0,1,4.05,4v8.06c0,1.85-1.64,3.53-4.82,3.53h-.56l5.58,8.37H233l-5.29-8.2h-6.36v8.2Zm5.6-13h12V74.45h-12v6.21Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M249.08,93.64h-1.9c-2.48,0-3.67-1.43-3.67-3.51V87h5.57v1.86h11.83V83.94H247.33a3.48,3.48,0,0,1-3.72-3.48V73.34a3.65,3.65,0,0,1,3.76-3.67h15.52a3.52,3.52,0,0,1,3.55,3.83v2.86h-5.53v-1.9H249.08v4.72h13.53a3.68,3.68,0,0,1,3.83,3.87v6.84a3.39,3.39,0,0,1-3.71,3.75Z"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "271.78 93.64 271.78 69.67 277.46 69.67 277.46 79.26 288.29 69.67 295.99 69.67 283.07 80.8 296.45 93.64 288.49 93.64 277.46 82.74 277.46 93.64 271.78 93.64"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M57.78,54.43H96.94a6.21,6.21,0,0,1,6.21,6.21v42a6.21,6.21,0,0,1-6.21,6.21H57.78a6.2,6.2,0,0,1-6.2-6.2v-42A6.2,6.2,0,0,1,57.78,54.43Z"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "85.58 80.23 95.76 67.46 95.73 67.42 81.02 74.51 77.39 58.59 77.33 58.59 73.7 74.51 58.99 67.42 58.96 67.46 69.14 80.23 54.43 87.31 54.44 87.36 70.77 87.36 67.14 103.28 67.18 103.3 77.36 90.53 87.54 103.3 87.58 103.28 83.95 87.36 100.28 87.36 100.29 87.31 85.58 80.23"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaerskLogoRgb);
export default __webpack_public_path__ + "static/media/Maersk_Logo_RGB.d21170a7019eb427c2e0726efc57c1ab.svg";
export { ForwardRef as ReactComponent };